<template>
  <v-container>
        <v-container fluid>
            <v-row align="start" justify="center">
                <span>
                    <h1>¿Que es Wall Audit?</h1>
                </span>
            </v-row>
            <v-col cols="12" md="4" sm="12" xs="12" align="center">
              <p class="text-sm-center text-xs-center text-md-left">
                  Autor: Wall Audit. Fecha: 07/06/20
              </p>
                </v-col>
            <v-row>
                <p>
                 Wall Auidt es una empresa dedicada a las IT, siendo su principal objetivo la seguridad de la información en todo lo que hace. 
                </p>
            </v-row>    
        </v-container>
    </v-container>
</template>

<script>
export default {

}
</script>

<style>

</style>